import thomasPic from "@/public/images/artists/thomas.png";
import { Artist } from "@/types/types";

export const thomas = {
  id: "155",
  name: "Thomas",
  image: thomasPic,
  description: `Thomas's voice carries a captivating tone with a subtle, bright edge, effortlessly blending into Pop and EDM tracks while maintaining a distinct identity. His vocals stand out with a unique character, yet remain versatile enough to lend themselves to the soulful depths of R&B and the raw energy of rock.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fthomas-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: [
        "Unprocessed",
        "Pop",
        "Dance",
        "RnB",
        "Rock",
        "Blues",
        "Jazz",
        "Soundtrack",
        "Ballads",
      ],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "Mid",
      },
      specific: {
        low: 46,
        high: 70,
      },
      sweetSpot: 60,
    },
  },
} as const satisfies Artist;
